import React from "react";

import cx from "classnames";
import { Dropdown } from "react-bootstrap";
import TruncateWithTooltip from "src/components/truncateWithTooltip";

import { WorkspaceItem } from "src/types/experiences/workspaces";

import styles from "./workspaceSelector.module.scss";

interface WorkspaceSelectorProps {
  workspaces: WorkspaceItem[];
  selectedId: string | null;
  className?: string;
  onSelect: (id: string) => void;
}

export const WorkspaceSelector: React.FC<WorkspaceSelectorProps> = ({
  workspaces,
  selectedId,
  className,
  onSelect,
}) => {
  const selectedName =
    workspaces.find((w) => w.id === selectedId)?.name || "Select workspace";
  const hasMultipleWorkspaces = workspaces.length > 1;

  // With a single (or no) workspace there's nothing to switch to — render the
  // name as static text without the dropdown menu or the toggle icon.
  if (!hasMultipleWorkspaces) {
    return (
      <div className={cx(styles.selector, className)}>
        <label>Workspace:</label>
        <TruncateWithTooltip
          className={styles.toggleLabel}
          placement="bottom"
          text={selectedName}
        />
      </div>
    );
  }

  return (
    <div className={cx(styles.selector, className)}>
      <label>Workspace:</label>

      <Dropdown>
        <Dropdown.Toggle className={styles.dropDown} as="div">
          <TruncateWithTooltip
            className={styles.toggleLabel}
            placement="bottom"
            text={selectedName}
          />
          <i className="paperflite-dropdown" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {workspaces.map((workspace, index) => {
            const active = workspace.id === selectedId;
            return (
              <Dropdown.Item
                active={active}
                key={index}
                onClick={() => onSelect(workspace.id)}
              >
                <TruncateWithTooltip
                  className={styles.toggleLabel}
                  placement="bottom"
                  text={workspace.name}
                />
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
